export default __webpack_public_path__ + "static/media/a012-market-line-4.2b730018.svg";